<template>
  <v-app style="background: #e7eaeb" :style="this.$customStyle" class="app">
    <v-overlay color="primary" opacity=".6" :value="loading" z-index="1000">
      <Logo />
    </v-overlay>

    <router-view @AccessDenied="showErrorAlert" />
  </v-app>
</template>

<style lang="scss">
.block {
  width: 100px;
  height: 100px;
  background: red;
}
@keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}

.loading-page {
  position: fixed;
  top: 45%;
  right: 50%;
  z-index: 1000;
  padding: 1rem;
  text-align: center;
  font-size: 3rem;
  font-family: sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loading {
  display: inline-block;
  width: 3.2rem;
  height: 3.2rem;
  border: 8px solid #cadbdf;
  border-radius: 50%;
  border-top-color: #426483;
  animation: spin 1s ease-in-out infinite;
}

.app {
  z-index: 10;
}
.bg {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 50%;
}
.bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.inputBackground {
  background-color: #f5f5f5;
}

.loader {
  background: transparent url('./assets/icon-1.1s-47px.gif') center no-repeat;
  height: 400px;
  width: 400px;
}

.label-color .v-label {
  color: dimgray !important;
  opacity: 1;
}

.v-label {
  color: dimgray !important;
  opacity: 1;
}

.v-label--is-disabled {
  color: rgba(0, 0, 0, 0.38) !important;
  opacity: 1;
}

#iconTitle {
  background: #bbcf20;
  width: 60px;
  height: 60px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-content: center;
  margin-right: 10px;
}

.item {
  background: #e7eaeb !important;
  padding: 0 8px !important;
}

.item span {
  font-size: 0.9rem;
  color: #4c4d4a;
}

.back {
  background: #ffffff !important;
}

th {
  background-color: #e7eaeb;
}

.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 45px !important;
}

.v-text-field--enclosed .v-input__prepend-inner,
.v-text-field--enclosed .v-input__append-inner {
  margin-top: 11px !important;
}

@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}

@media (max-width: 600px) {
  .v-toolbar__content {
    padding: 0 !important;
    margin-left: 1rem;
    margin-right: 1rem;
  }

  #iconTitle {
    width: 45px;
    height: 45px;
  }

  #icon {
    font-size: 25px !important;
  }
}
</style>

<script>
import Vue from 'vue'
import anime from 'animejs'
import Logo from './components/animation/load.vue'
import ApiService from './services/ApiService'

export default {
  name: 'PagesIndex',

  components: {
    Logo,
  },

  data: () => ({
    error: '',
    showError: false,
    loading: false,
    apiService: new ApiService(),
    interval: null,
  }),

  created() {
    Vue.$globalEvent.$on('loader', (item) => {
      this.loading = item
    })

    this.$i18n.locale = localStorage.getItem('locale')

    const institution = JSON.parse(localStorage.getItem('institution'))

    Number.prototype.toInstLocale = function () {
      const currency =
        institution && institution.currencyLocale
          ? institution.currencyLocale
          : 'es-ES'

      let currencyStyle = 'USA'

      switch (currency) {
        case 'es-ES':
          currencyStyle = 'USA'
          break
        case 'es-CO':
          currencyStyle = 'COP'
          break
        case 'es-ES':
          currencyStyle = 'EUR'
          break
      }

      if (this) {
        return this.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        })
      }
      return this
    }

    String.prototype.toInstLocale = function () {
      const currency =
        institution && institution.currencyLocale
          ? institution.currencyLocale
          : 'es-ES'

      let currencyStyle = 'EUA'

      switch (currency) {
        case 'es-ES':
          currencyStyle = 'EUA'
          break
        case 'es-CO':
          currencyStyle = 'COP'
          break
        case 'es-ES':
          currencyStyle = 'EUR'
          break
      }

      if (this) {
        return parseFloat(this).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        })
      }
      return this
    }
  },

  methods: {
    showErrorAlert(message) {
      this.error = message
      this.showError = true
      setTimeout(() => {
        this.showError = false
      }, 4000)
    },

    go() {
      anime({
        // <-- using imported
        targets: this.$refs.square,
        translateX: 500,
      })
    },
  },
}
</script>
